import {
    CREATE_LEAD_PROFILE_LEAD_FINANCE,
    CREATE_LEAD_PROFILE_LEAD_FINANCE_SUCCESS,
    CREATE_LEAD_PROFILE_LEAD_FINANCE_FAILURE,

    READ_LEAD_PROFILE_LEAD_FINANCE,
    READ_LEAD_PROFILE_LEAD_FINANCE_SUCCESS,
    READ_LEAD_PROFILE_LEAD_FINANCE_FAILURE,
} from '../constants/lead_profile_lead_finance.constants';


export const createLeadProfileLeadFinanceRequest = params => ({
    type: CREATE_LEAD_PROFILE_LEAD_FINANCE, params,
});

export const createLeadProfileLeadFinanceSuccess = data => ({
    type: CREATE_LEAD_PROFILE_LEAD_FINANCE_SUCCESS, data,
});

export const createLeadProfileLeadFinanceFailure = error => ({
    type: CREATE_LEAD_PROFILE_LEAD_FINANCE_FAILURE, error,
});


export const readLeadProfileLeadFinanceRequest = params => ({
    type: READ_LEAD_PROFILE_LEAD_FINANCE, params,
});

export const readLeadProfileLeadFinanceSuccess = data => ({
    type: READ_LEAD_PROFILE_LEAD_FINANCE_SUCCESS, data,
});

export const readLeadProfileLeadFinanceFailure = error => ({
    type: READ_LEAD_PROFILE_LEAD_FINANCE_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/lead_profile_lead_finance.actions.js